export default __webpack_public_path__ + "662ed6e15f4a4d0c597c6d6c0ae3a8b0.jpg";